import _asyncToGenerator from "/home/runner/work/mainrepo/mainrepo/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { ChangeDetectorRef, ElementRef, NgZone } from '@angular/core';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map, throttleTime } from 'rxjs/operators';
import { UiTooltipContentComponent } from '../tooltip';
import { CustomVimeComponent } from './vime.component';
import { CommonModule } from '@angular/common';
import * as i0 from "@angular/core";
import * as i1 from "../tooltip/tooltip-content.component";
import * as i2 from "../tooltip/tooltip.directive";
import * as i3 from "@angular/common";
const _c0 = ["slider"];
const _c1 = ["tooltip"];
const _c2 = ["tooltipBlocked"];
const _c3 = ["blockedZoneIndicator1"];
const _c4 = ["blockedZoneIndicator2"];
const _c5 = () => ({
  trigger: "hover"
});
const _c6 = () => ({
  hideOnScroll: false,
  placement: "top",
  hideOnMouseLeave: false
});
export let VideoScrubberComponent = /*#__PURE__*/(() => {
  class VideoScrubberComponent extends CustomVimeComponent {
    get lockJumpAfterEnabled() {
      return typeof this.lockJumpAfter$.getValue() === 'number';
    }
    set lockJumpAfter(val) {
      if (typeof val !== 'number' && val !== false) throw new TypeError('lockJumpAfter: invalid arg type');
      this.lockJumpAfter$.next(val);
    }
    constructor(c, ref, z) {
      super(c, ref, z);
      this.c = c;
      this.ref = ref;
      this.z = z;
      this.noKeyboard = false;
      this.hideTooltip = false;
      this.lockJumpForwards = false;
      this.lockJumpBackwards = false;
      this.lockJumpAfter$ = new BehaviorSubject(false);
      this.currentTimeThrottled$ = this.currentTime$.pipe(throttleTime(250));
      this.endTime$ = this.duration$.pipe(map(val => {
        return Math.max(0, val) || 0;
      }));
      this.allowedMin$ = this.lockJumpBackwards ? combineLatest([this.currentTime$, this.endTime$]).pipe(map(([currTime, endTime]) => {
        return currTime / endTime;
      })) : new BehaviorSubject(0);
      this.allowedMax$ = combineLatest([this.currentTime$, this.lockJumpAfter$, this.endTime$]).pipe(map(([currTime, lockJumpAfter, endTime]) => {
        if (this.lockJumpAfterEnabled) return lockJumpAfter / endTime;else if (this.lockJumpForwards) return currTime / endTime;else return 1;
      }));
      // console.log('scrubber',this)
    }
    assignProps() {
      super.assignProps(['i18n', 'currentTime', 'duration', 'buffering', 'paused', 'buffered'], ['duration', 'currentTime']);
    }
    ngAfterViewInit() {
      var _superprop_getNgAfterViewInit = () => super.ngAfterViewInit,
        _this = this;
      return _asyncToGenerator(function* () {
        _superprop_getNgAfterViewInit().call(_this);
        // add +- 0.5 for more beautiful rendering and access to slider control handle
        _this.allowedMin$.subscribe(val => {
          _this.blockedZoneIndicator1.nativeElement?.style.setProperty('--position-value', val * 100 - 0.5 + '%');
        });
        _this.allowedMax$.subscribe(val => {
          _this.blockedZoneIndicator2.nativeElement?.style.setProperty('--position-value', val * 100 + 0.5 + '%');
        });
      })();
    }
    onSeek(event) {
      const requestedTime = event.detail;
      if (this.lockJumpBackwards && this.lockJumpForwards) return false;
      if (this.lockJumpBackwards && requestedTime < this.currentTime) return false;
      if (this.lockJumpForwards && requestedTime > this.currentTime) return false;
      if (this.lockJumpAfterEnabled && requestedTime > this.lockJumpAfter$.getValue()) return false;
      this.dispatch('currentTime', event.detail);
    }
    getSliderInput() {
      // return this.slider.shadowRoot?.querySelector('input') as HTMLInputElement;
    }
    static {
      this.ɵfac = function VideoScrubberComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || VideoScrubberComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: VideoScrubberComponent,
        selectors: [["ui-video-scrubber"]],
        viewQuery: function VideoScrubberComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5)(_c1, 5)(_c2, 5)(_c3, 5)(_c4, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.slider = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tooltip = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tooltipBlocked = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.blockedZoneIndicator1 = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.blockedZoneIndicator2 = _t.first);
          }
        },
        inputs: {
          lockJumpForwards: "lockJumpForwards",
          lockJumpBackwards: "lockJumpBackwards",
          lockJumpAfter: "lockJumpAfter"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 12,
        vars: 13,
        consts: [["slider", ""], ["blockedZoneIndicator1", ""], ["blockedZoneIndicator2", ""], ["tooltipBlocked", ""], [1, "scrubber"], [3, "vmValueChange", "step", "max", "value", "label"], [1, "blocked-zone-indicator", "before"], [1, "blocked-zone-indicator", "after", 3, "uiTooltipTrigger", "uiTooltipTriggerOptions"], ["size", "mini", "theme", "alert", 3, "uiTooltipOptions"]],
        template: function VideoScrubberComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 4)(1, "vm-slider", 5, 0);
            i0.ɵɵpipe(3, "async");
            i0.ɵɵpipe(4, "async");
            i0.ɵɵlistener("vmValueChange", function VideoScrubberComponent_Template_vm_slider_vmValueChange_1_listener($event) {
              return ctx.onSeek($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelement(5, "div", 6, 1)(7, "div", 7, 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "ui-tooltip-content", 8, 3);
            i0.ɵɵtext(11, " Vorw\u00E4rts springen ist nicht erlaubt. ");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const tooltipBlocked_r1 = i0.ɵɵreference(10);
            i0.ɵɵadvance();
            i0.ɵɵproperty("step", 0.01)("max", i0.ɵɵpipeBind1(3, 7, ctx.endTime$))("value", i0.ɵɵpipeBind1(4, 9, ctx.currentTimeThrottled$))("label", ctx.i18n == null ? null : ctx.i18n.scrubber);
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("uiTooltipTrigger", tooltipBlocked_r1)("uiTooltipTriggerOptions", i0.ɵɵpureFunction0(11, _c5));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("uiTooltipOptions", i0.ɵɵpureFunction0(12, _c6));
          }
        },
        dependencies: [CommonModule, i1.UiTooltipContentComponent, i2.UiTooltipTriggerDirective, i3.AsyncPipe],
        styles: ["[_nghost-%COMP%]{--vm-tooltip-spacing: var(--vm-scrubber-tooltip-spacing);flex:1;position:relative;cursor:pointer;pointer-events:auto;box-sizing:border-box;left:calc(var(--vm-slider-thumb-width) / 2);margin-right:var(--vm-slider-thumb-width);margin-bottom:var(--vm-slider-track-height);display:block;height:15px}@keyframes _ngcontent-%COMP%_progress{to{background-position:var(--vm-scrubber-loading-stripe-size) 0}}.scrubber[_ngcontent-%COMP%]{position:relative;width:100%}vm-slider[_ngcontent-%COMP%], progress[_ngcontent-%COMP%]{width:100%;--vm-slider-track-height: 6px;--vm-slider-track-focused-height: 8px}vm-slider[_ngcontent-%COMP%]:hover, progress[_ngcontent-%COMP%]:hover{cursor:pointer}vm-slider[_ngcontent-%COMP%]{position:absolute;top:5px;left:0;z-index:3}.blocked-zone-indicator[_ngcontent-%COMP%]{--blockedCl: rgba(142, 41, 41, .5);--blockedClFade: rgba(142, 41, 41, 0)}.blocked-zone-indicator[_ngcontent-%COMP%]{background:var(--blockedCl);position:absolute;top:0;z-index:5;height:16px;opacity:0;transition:opacity .2s}.blocked-zone-indicator.before[_ngcontent-%COMP%]{width:var(--position-value);left:0;background:linear-gradient(to right,var(--blockedCl) calc(100% - 10px),var(--blockedClFade) 100%)}.blocked-zone-indicator.after[_ngcontent-%COMP%]{left:var(--position-value);right:0;background:linear-gradient(to left,var(--blockedCl) calc(100% - 10px),var(--blockedClFade) 100%)}.blocked-zone-indicator[_ngcontent-%COMP%]:hover{cursor:not-allowed}[_nghost-%COMP%]   .blocked-zone-indicator[_ngcontent-%COMP%]{opacity:1}"],
        changeDetection: 0
      });
    }
  }
  return VideoScrubberComponent;
})();